import React, { useState, useEffect, useRef, useCallback } from 'react';
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import { useAuth } from '../../contexts/auth';

import './LoginForm.scss';
import { localStorageService } from '../../services/localstorage-service';

export default function LoginForm() {
  const { signIn } = useAuth();
  const [isChecked, setIsChecked] = useState(localStorageService.getIsChecked());
  const [loading, setLoading] = useState(false);
  const formData = useRef({ email: localStorageService.getEmail(), password: '' });

  const toast = (message) => {
    notify({
      message: message,
      position:
        { my: 'top center', at: 'top center', of: window, offset: '0 70' }
    }, 'error', 5000);
  };
  const emailValidation = (email) => {
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return !(!email || regex.test(email) === false);
  };

  const normalizeLoginEmail = (raw) => {
    if (!raw) {
      return '';
    }
    const trimmed = raw.trim().replace(/\s+/g, '');
    const colonIndex = trimmed.indexOf(':');
    if (colonIndex < 0) {
      return trimmed;
    }
    const chain = trimmed.slice(0, colonIndex).trim();
    const localPart = trimmed.slice(colonIndex + 1).trim().toLowerCase();
    return `${chain}:${localPart}`;
  };

  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    const { password } = formData.current;
    const email = normalizeLoginEmail(formData.current.email);
    formData.current.email = email;

    const colonIndex = email.indexOf(':');
    if (colonIndex < 0) {
      toast('Kolon mangler. Bruk formatet kjedenavn:epost@domene.no');
      return;
    }
    if (colonIndex === 0) {
      toast('Kjedenavn er påkrevet');
      return;
    }
    const localEmail = email.slice(colonIndex + 1);
    if (!emailValidation(localEmail)) {
      toast('Vennligst tast inn en gyldig epost-adresse');
      return;
    }
    setLoading(true);
    const result = await signIn(email, password, localStorageService.getIsChecked());
    setLoading(false);
    if (!result.isOk) {
      toast(result.message);
      //window.location.reload(true);
    }
    else if (result.isOk) {
      if (localStorageService.getIsChecked() && email !== "") {
        localStorageService.setEmail(email);
      }
      window.location.reload(true);
    }
  }, [signIn]);

  useEffect(() => {
    (async function () {
      const result = await localStorageService.getIsChecked();
      setIsChecked(result);
      setLoading(false);
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      var a2hsBannerDiv = document.querySelector('.block__install');
      if (navigator.standalone || isStandalone) {
        if (a2hsBannerDiv)
          a2hsBannerDiv.style.display = 'none';
        return 'standalone';
      }
      else if (window.location.hash !== "#/login") {
        if (a2hsBannerDiv)
          a2hsBannerDiv.style.display = 'none';
      }
      else {
        // Install banner covers "Glemt passord?" on mobile — keep it hidden on login.
        if (a2hsBannerDiv)
          a2hsBannerDiv.style.display = 'none';
      }
    })();
  }, []);

  const onChange = (e) => {
    setIsChecked(e.target.checked);
    localStorageService.setIsChecked(e.target.checked)
  };

  return (
    <form className={'login-form'} onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading}>
        <Item
          dataField={'email'}
          editorType={'dxTextBox'}
          editorOptions={emailEditorOptions}
        >
          <RequiredRule message="E-post er påkrevd" />
          {/* <EmailRule message="E-posten er ugyldig" /> */}
          <Label visible={false} />
        </Item>
        <Item
          dataField={'password'}
          editorType={'dxTextBox'}
          editorOptions={passwordEditorOptions}
        >
          <RequiredRule message="Passord er påkrevd" />
          <Label visible={false} />
        </Item>
        <Item>
          <label>
            <input type="checkbox"
              checked={isChecked}
              onChange={e => onChange(e)} />
            <span>Husk meg</span>
          </label>
        </Item>
        <ButtonItem>
          <ButtonOptions
            width={'100%'}
            type={'default'}
            useSubmitBehavior={true}
          >
            <span className="dx-button-text">
              {
                loading
                  ? <LoadIndicator height={24} width={24} indicatorSrc="loading-buffering.gif"/>
                  : 'Logg inn'
              }
            </span>
          </ButtonOptions>
        </ButtonItem>
      </Form>
      <p className="login-format-hint">Logg inn med kjedenavn:epost@domene.no</p>
      <div className="link">
        <a href="#/forgot-password">Glemt passord?</a>
      </div>
    </form>
  );
}

const emailEditorOptions = { stylingMode: 'filled', placeholder: 'Kjede:epost@eksempel.no', mode: 'text' };
const passwordEditorOptions = { stylingMode: 'filled', placeholder: 'Passord', mode: 'password' };
